// extracted by mini-css-extract-plugin
export default {"badge":"TaskCategoryBadge_badge__MXuAl","flex":"TaskCategoryBadge_flex__0z+Ap"};